import api from '../utils/api';
import { cloudinaryService } from './cloudinaryService';
import { apiCache } from '../utils/cache';

export const assetService = {
  getAllAssets: async (useCache = true) => {
    const cacheKey = 'assets-all';
    
    // Check cache first
    if (useCache) {
      const cached = apiCache.get(cacheKey);
      if (cached) {
        console.log('📦 Using cached assets data');
        return cached;
      }
    }
    
    // Fetch from API
    const response = await api.get('/api/admin/assets');
    const data = response.data;
    
    // Cache the response for 3 minutes
    apiCache.set(cacheKey, data, 3 * 60 * 1000);
    
    return data;
  },
  
  createAsset: async (assetData) => {
    const response = await api.post('/api/admin/assets', assetData);
    // Invalidate cache after creating asset
    apiCache.invalidate('assets-all');
    return response.data;
  },
  
  updateAsset: async (assetId, assetData) => {
    const response = await api.put(`/api/admin/assets/${assetId}`, assetData);
    // Invalidate cache after updating asset
    apiCache.invalidate('assets-all');
    return response.data;
  },
  
  deleteAsset: async (assetId) => {
    const response = await api.delete(`/api/admin/assets/${assetId}`);
    // Invalidate cache after deleting asset
    apiCache.invalidate('assets-all');
    return response.data;
  },
  
  // New method for deleting Cloudinary images
  deleteImage: async (imageUrl) => {
    return await cloudinaryService.deleteImage(imageUrl);
  },
  
  // New method for deleting all asset images
  deleteAssetImages: async (asset) => {
    return await cloudinaryService.deleteAssetImages(asset);
  },
  
  setDeploymentTimer: async (assetId, days) => {
    const response = await api.post(`/api/admin/asset/${assetId}/set_deployment_timer`, { days });
    return response.data;
  },
  
  confirmDeployed: async (assetId) => {
    const response = await api.post(`/api/admin/asset/${assetId}/confirm_deployed`);
    return response.data;
  },
  
  getAssetPurchases: async (assetId) => {
    const response = await api.get(`/api/admin/asset/${assetId}/purchases`);
    return response.data;
  },

  // Fetch all curation packages
  getAllCurationPackages: async () => {
    const response = await api.get('/api/admin/curation-packages');
    return response.data;
  },

  updateAssetSequences: async (sequences) => {
    const response = await api.put('/api/admin/assets/update-sequences', sequences);
    // Invalidate cache after updating sequences
    apiCache.invalidate('assets-all');
    return response.data;
  }
};